import React from 'react';
import Box from '@mui/material/Box';
import ParkRoundedIcon from '@mui/icons-material/ParkRounded';
import PublicRoundedIcon from '@mui/icons-material/PublicRounded';
import CalculateRoundedIcon from '@mui/icons-material/CalculateRounded';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';

// Shared with the independent V4 mockup: pastel course icon + stable semantic color.
// These are navigation aids, not a ranking or judgment about students' abilities.
const themes = {
  life: { color: '#188664', background: '#dff7ea', line: '#3aa57e', icon: ParkRoundedIcon },
  english: { color: '#ad5c15', background: '#fff0dc', line: '#ed9c4a', icon: PublicRoundedIcon },
  math: { color: '#2768c5', background: '#e1eeff', line: '#5c8ee2', icon: CalculateRoundedIcon },
  turkish: { color: '#ae3f6d', background: '#ffe6ef', line: '#dd6b94', icon: MenuBookRoundedIcon },
  general: { color: '#6950b3', background: '#eee9ff', line: '#8668db', icon: SchoolRoundedIcon },
};
export const getCourseVisual = (label) => {
  const name = String(label || '').trim().toLocaleLowerCase('tr-TR');
  if (name.includes('hayat bilgisi')) return themes.life;
  if (name.includes('ingilizce') || name.includes('yabancı dil')) return themes.english;
  if (name.includes('matematik')) return themes.math;
  if (name.includes('türkçe')) return themes.turkish;
  return themes.general;
};

export function CourseGlyph({ name, size = 34 }) {
  const visual = getCourseVisual(name);
  const Icon = visual.icon;
  return (
    <Box data-testid="course-glyph" aria-hidden="true" sx={{
      width: size, height: size, flexShrink: 0, display: 'grid', placeItems: 'center',
      borderRadius: 2.3, bgcolor: visual.background, color: visual.color,
    }}>
      <Icon sx={{ fontSize: Math.round(size * 0.59) }} />
    </Box>
  );
}
